/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS0Icon16Regular = forwardRef('MediaAudioVolumeS0Icon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.505 1.658A.9.9 0 0 1 9 2.332v11.336a.9.9 0 0 1-1.495.675L3.716 11H1.5A1.5 1.5 0 0 1 0 9.5v-3A1.5 1.5 0 0 1 1.5 5h2.216l3.789-3.342ZM7.5 3.662 4.638 6.187a1.25 1.25 0 0 1-.827.313H1.5v3h2.311c.305 0 .599.111.827.313L7.5 12.338V3.662Z" })));
});
